import { currencies } from './assets/templates';

/**
 * valida que los campos que tengan el atributo required tengan algun valor
 * @param {Array} requiredFields
 */
const validateRequiredFields = (requiredFields) => {
  const results = [];
  (requiredFields || document.querySelectorAll('[required]')).forEach((field, index) => {
    if (!field.value) return results.push(false);
    if (index === requiredFields?.length) return results.push(true);
    return results.push(true);
  });

  return results.every((field) => field === true);
};

export default validateRequiredFields;

/**
 * convierte un archivo blob a base64
 * @param {Array} requiredFields
 */
export const convertBase64 = (file) => {
  if (!file) return undefined;

  if (file instanceof Blob) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
        fetch(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  const reader = new FileReader();
  // reader.addEventListener('load', readFile);
  return reader.readAsText(file);
};

export const toInteger = (value, decimals) => {
  if (typeof value === 'string') {
    if (Number.isInteger(Number(value))) {
      return Number(value);
    }
    return Number(Number(value).toFixed(decimals || 0));
  }
  if (typeof value === 'number') {
    if (Number.isInteger(Number(value))) {
      return value;
    }
    return (Number(value.toFixed(decimals || 0)));
  }

  return 0;
};

export const changeCurrency = (rate, currencyCode, setter, state) => {
  let mockRate = rate;
  if (state.currentCurrencyRate) {
    mockRate = rate / state.currentCurrencyRate;
  }

  const mockMaterialValues = state.material.values.map((material) => ({
    ...material,
    cost: material.cost * mockRate,
    costPerDesign: material.costPerDesign * mockRate,
    costPerPiece: material.costPerPiece * mockRate,
  }));
  const [currency] = currencies.filter((item) => item.currencyCode === currencyCode);

  setter({
    ...state,
    currentCurrencyRate: rate,
    currentCurrency: currency,
    design: {
      ...state.design,
      costPerDesign: (state.design?.costPerDesign || 0) * mockRate,
    },
    electricity: {
      ...state.electricity,
      electricityCostPerDesign: (state.electricity?.electricityCostPerDesign || 0) * mockRate,
    },
    machine: {
      ...state.machine,
      shopifyPrice: (state.machine?.shopifyPrice || 0) * mockRate,
    },
    material: {
      ...state.material,
      costPerPiece: (state.material?.costPerPiece || 0) * mockRate,
      values: mockMaterialValues,
    },
    price: {
      ...state.price,
      designFullCost: (state.price?.designFullCost || 0) * mockRate,
      profitInCurrency: (state.price?.profitInCurrency || 0) * mockRate,
      salePricePerDesign: (state.price?.salePricePerDesign || 0) * mockRate,
    },
    worker: {
      ...state.worker,
      employeeSalaryPerMonth: (state.worker?.employeeSalaryPerMonth || 0) * mockRate,
      productionCostPerDesign: (state.worker?.productionCostPerDesign || 0) * mockRate,
    },
  });
};
